// Module
var code = "<h4 class=\"amt-filter-section font-bold\" ng-bind=\"label\" ng-hide=\"!label\"></h4> <div class=\"row\" ng-transclude> </div>";
// Exports
module.exports = code;